export const PACKAGES_FEATURES_SEARCH_ROLE_MODULES_RESULT = "PACKAGES_FEATURES_SEARCH_ROLE_MODULES_RESULT";
export const PACKAGES_FEATURES_SEARCH_ROLE_MODULES_REQUEST = "PACKAGES_FEATURES_SEARCH_ROLE_MODULES_REQUEST";

export const PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_REQUEST = "PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_REQUEST";
export const PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_RESULT = "PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_RESULT";

export const PACKAGES_FEATURES_UPDATE_ROLE_MODULES_REQUEST = "PACKAGES_FEATURES_UPDATE_ROLE_MODULES_REQUEST";
export const PACKAGES_FEATURES_UPDATE_ROLE_MODULES_RESULT = "PACKAGES_FEATURES_UPDATE_ROLE_MODULES_RESULT";

export const PACKAGES_FEATURES_SET_ROLE_MODULES = "PACKAGES_FEATURES_SET_ROLE_MODULES";
